import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgStructure = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.5 6.516V4.984c0-.819.662-1.484 1.48-1.484h4.042A1.48 1.48 0 0 1 15.5 4.984v1.532A1.48 1.48 0 0 1 14.022 8H9.979C9.162 8 8.5 7.336 8.5 6.516M3 19.016v-1.532C3 16.665 3.662 16 4.48 16h4.042A1.48 1.48 0 0 1 10 17.484v1.532A1.48 1.48 0 0 1 8.522 20.5H4.479C3.662 20.5 3 19.836 3 19.016M14 19.016v-1.532c0-.819.662-1.484 1.48-1.484h4.042A1.48 1.48 0 0 1 21 17.484v1.532a1.48 1.48 0 0 1-1.478 1.484h-4.043c-.817 0-1.479-.664-1.479-1.484"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M12 8v4M17.5 16v-2a2 2 0 0 0-2-2h-7a2 2 0 0 0-2 2v2"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgStructure);
export default ForwardRef;
